import React from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import "../css/DeleteSpecialOnboarding.css";

const DeleteSpecialOnboarding = ({ open, onClickYes, onClose, isLoading }) => {
  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "delete-special-onboarding-dialog-container",
      }}
    >
      <DialogContent>
        <div className="delete-special-onboarding-dialog-content">
          <div className="delete-special-onboarding-dialog-title-container">
            <div className="delete-special-onboarding-dialog-title">
              Delete Special Onboarding
            </div>
            <div className="delete-special-onboarding-dialog-subtitle">
              Do you want to delete this Special Onboarding? This operation can
              not be reverted
            </div>
          </div>
          <Button
            variant="contained"
            onClick={!isLoading ? onClickYes : null}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Yes
          </Button>
          <Button variant="contained" className="no-button" onClick={onClose}>
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteSpecialOnboarding;
